export function validateCardholderName(cardholderName) {
    // A cardholder's name can be a mix of upper and lower case characters as well as spaces, periods, dashes,
    // and apostrophes. A name must have at least one character and can have at most 255 characters.
    // Valid examples include: Bobby Demo, Bobby D'Emo, Bobby Demo-Test
    var CARDHOLDERNAME_REGEX = /^[-a-zA-Z' .]{1,255}$/;
    return CARDHOLDERNAME_REGEX.test(cardholderName);
}
export function validateZipcode(zipCode) {
    // A zipcode can have up to 12 characters. Those characters can be digits or dashes. A zip must be at least 5 digits
    // long and can be up to 12 digits or dashes long.
    // Valid examples include: 10032, 77035-1234
    var ZIPCODE_REGEX = /^[\d-]{5,12}$/;
    return ZIPCODE_REGEX.test(zipCode);
}
